import PropTypes from 'prop-types';
import React from 'react';
import ReactCollapse from 'react-collapse';

import { ContentZonesService, LocaleService } from '@sm360/widget-commons-core-services';
import { ModelYear } from '@sm360/widget-commons-vehicle';

import { DRIVE_POWER_TRAINS } from 'build-and-quote/constants/sections.js';
import { getSectionAdditionalClasses } from 'build-and-quote/services/SectionClassesUtils/SectionClassesUtils.js';
import DrivePowerTrain from 'build-and-quote/components/DrivePowerTrains/DrivePowerTrain.jsx';

import 'build-and-quote/components/DrivePowerTrains/drivePowerTrains.scss';

const DrivePowerTrains = ({ currentSection, modelYear, selectDrivePowerTrain, selectedModel, hasAdobeTagging }) => {
    const availableDrivePowerTrains = modelYear.getAvailableDriveTrains().toArray();
    const sectionOpened = currentSection === DRIVE_POWER_TRAINS.value;

    const DrivePowerTrainList = availableDrivePowerTrains.map((drivePowerTrain, index) => (
        <DrivePowerTrain
            key={drivePowerTrain.selectionCode}
            optionIndex={index + 1}
            drivePowerTrain={drivePowerTrain}
            bestConfiguration={modelYear.getOptionsPackageConfigurationFromCode(drivePowerTrain.bestOptionsPackageCode)}
            onDrivePowerTrainClick={() => selectDrivePowerTrain(drivePowerTrain)}
            hasAdobeTagging={hasAdobeTagging}
        />
    ));

    const availableDrivePowerTrainsSection = availableDrivePowerTrains.length > 0 && (
        <div className="bloc-options__listing">{DrivePowerTrainList}</div>
    );

    const sectionClasses = ['bloc-container', 'section-drive-power-trains', 'section-background'];
    const sectionAdditionalClasses = getSectionAdditionalClasses(
        sectionClasses,
        sectionOpened,
        currentSection,
        DRIVE_POWER_TRAINS.value
    ).join(' ');

    const genericTitle = ContentZonesService.getContentZone('widget.build.and.buy', 'vehicle.title.text')
        ? ContentZonesService.getContentZone('widget.build.and.buy', 'vehicle.title.text').getValue()
        : LocaleService.t('modelYearSection.title');

    const sectionTitle = LocaleService.t('SECTIONS.TITLE.GENERAL', {
        title: genericTitle,
        model: `${selectedModel.model}`,
    });
    const sectionSubtitle =
        availableDrivePowerTrains.length > 1
            ? LocaleService.t('drivePowerTrainSection.subtitle_2', {
                  optionlength: `${availableDrivePowerTrains.length}`,
              })
            : LocaleService.t('drivePowerTrainSection.subtitle_1', {
                  optionlength: `${availableDrivePowerTrains.length}`,
              });

    const background = `url(${ContentZonesService.getContentZone(
        'widget.build.and.buy',
        'performance.background.img'
    ).getValue()})`;

    return (
        <ReactCollapse isOpened={sectionOpened} springConfig={{ stiffness: 140, damping: 26 }}>
            <section className={sectionAdditionalClasses} style={{ backgroundImage: background }}>
                <div className="bloc-container-wrapper">
                    <div className="section-drive-power-trains__title">
                        <h3 className="sr-subtitle-1 is-centered">{sectionTitle}</h3>
                        <h4 className="sr-title-1 is-centered">{sectionSubtitle}</h4>
                    </div>
                    {availableDrivePowerTrainsSection}
                </div>
            </section>
        </ReactCollapse>
    );
};

DrivePowerTrains.propTypes = {
    currentSection: PropTypes.number.isRequired,
    modelYear: PropTypes.instanceOf(ModelYear.ModelYearModel).isRequired,
    selectDrivePowerTrain: PropTypes.func.isRequired,
    selectedModel: PropTypes.shape({
        make: PropTypes.string.isRequired,
        model: PropTypes.string.isRequired,
    }).isRequired,
    hasAdobeTagging: PropTypes.bool.isRequired,
};

DrivePowerTrains.displayName = 'DrivePowerTrains';

export default DrivePowerTrains;
